module.exports = __webpack_public_path__ + "assets/on-charging.de27e469.svg";